import { SortObject } from '../models/sortObject';

export default {
    constructSort: (sort: SortObject[], afterPagination: boolean = false) => {
        var query = '';
        if(sort && sort.length > 0) {
            sort.forEach(s => {
                let queryChain = null;
                if (afterPagination || query?.length >= 1) {
                    queryChain = '&sort=';
                } else if (query?.length < 1) {
                    queryChain = '?sort=';
                }
                query = query + queryChain + s.prop + ',' + s.dir
            })
        }
        return query;
    },
  };
  